<div class="p-grid mu-filter-toolbar">
  <div class="p-col">
    <div class="p-grid">
      <div class="p-col mu-filter-toolbar-title">{{ 'common.selectedFilters' | translate }}:</div>
      <div class="p-col-fixed mu-filter-toolbar-icon mu-filter-toolbar-icon-left" (mousedown)="scrollX(true)" (mouseup)="stopScrollX()">
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
      </div>
      <div class="p-col mu-filter-toolbar-items" id="mu-filter-toolbar-items">
        <div class="p-grid">
          <ng-container *ngFor="let filterField of filterFieldList">
            <ng-container *ngIf="isValidFilterValue(filterField)">
              <div
                class="p-col mu-filter-toolbar-item"
                *ngIf="filterField.getLabel(filterList.filterData) !== ''"
                [pTooltip]="filterField.getTooltipLabel(filterList.filterData)"
                tooltipPosition="top"
              >
                <ng-container *ngIf="filterField.useTemplate(filterList.filterData); else defaultLabel">
                  <ng-container
                    *ngTemplateOutlet="
                      filterField.labelTemplate;
                      context: { $implicit: getTranslatedLabel(filterField), field: filterField }
                    "
                  ></ng-container>
                </ng-container>
                <ng-template #defaultLabel>
                  <span [innerHTML]="getTranslatedLabel(filterField)"></span>
                </ng-template>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="p-col-fixed mu-filter-toolbar-icon" (mousedown)="scrollX()" (mouseup)="stopScrollX()">
        <i class="fas fa-chevron-right" aria-hidden="true"></i>
      </div>
    </div>
  </div>
  <div class="p-col-fixed mu-filter-toolbar-button">
    <p-button class="mu-button" (click)="showSideBar()" [label]="'common.filters' | translate" icon="fas fa-filter"></p-button>
  </div>
</div>
